/**
 * LEGACY iframe GamePopup for develop-era dists (assets/index-*.js + atemoya-host.js).
 * Remove when all games are rebuilt to game-launch.js.
 * See docs/ai-engineering/LEGACY_LAUNCH_FLOW.md
 */
import { useEffect, useRef } from 'react';
import { forwardGameGaEvent, trackGameReady } from '../../helpers/analytics';
import type { GamePopupProps } from './types';
import styles from './GamePopup.module.css';

type LegacyGamePopupProps = Omit<GamePopupProps, 'format'>;

export function LegacyGamePopup({ url, name, onClose }: LegacyGamePopupProps) {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        function handleMessage(event: MessageEvent) {
            const iframe = iframeRef.current;
            if (!iframe || event.source !== iframe.contentWindow) {
                return;
            }

            const data = event.data;
            if (!data || !data.type) {
                return;
            }

            if (data.type === 'atemoya-close') {
                onClose();
            } else if (data.type === 'atemoya-ready') {
                trackGameReady(name);
            } else if (data.type === 'atemoya-ga-event') {
                forwardGameGaEvent(data.eventName, data.eventParams);
            }
        }

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [name, onClose]);

    return (
        <div className={`${styles.popup} ${styles.active}`}>
            <div className={styles.overlay} />
            <div className={styles.content}>
                <div className={styles.body}>
                    <iframe
                        ref={iframeRef}
                        src={url}
                        title={name}
                        className={styles.iframe}
                        allowFullScreen
                    />
                </div>
            </div>
        </div>
    );
}
